import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-detailuser",
  "use": "icon-detailuser-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-detailuser\">\r\n<path id=\"icon-detailuser_Vector\" d=\"M8.004 0H7.77188C5.77088 0.12 4.13807 1.736 4.002 3.728C3.84992 6.064 5.68284 8 7.98799 8C10.1891 8 11.99 6.2 11.99 3.992C11.99 1.784 10.2051 0 8.004 0ZM8.004 9.336C5.33867 9.336 0 10.672 0 13.328V15.336C0 15.696 0.296148 16 0.664332 16H15.3357C15.7038 16 16 15.696 16 15.328V13.304C16.008 10.672 10.6693 9.336 8.004 9.336Z\" fill=\"#2C57FF\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol